import { formatURIComponent, makeRecommends } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '五星酒店',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        // description: `华美的定位可研服务，包括市场分析、竞品评估及财务可行性研究，确保项目精准匹配市场需求。许多投资者因忽视市场饱和度、客群偏好或运营成本测算而导致决策失误。华美依托行业数据库与实战经验，提供兼具数据支撑与落地性的解决方案，帮助客户规避风险、提升回报。`,
        icons: [
            {
                name: '位置+环境',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/位置环境'),
                path: "华美顾问/华美服务/五星酒店/位置环境"
            },
            {
                name: '开业年+装修年',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/开业年装修年'),
                path: "华美顾问/华美服务/五星酒店/开业年装修年"
            },
            {
                name: '长文+视频',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/长文视频'),
                path: "华美顾问/华美服务/五星酒店/长文视频"
            },
            {
                name: '高清图片',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/高清图片'),
                path: "华美顾问/华美服务/五星酒店/高清图片"
            },
            {
                name: '平面图',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/平面图'),
                path: "华美顾问/华美服务/五星酒店/平面图"
            },
            {
                name: '硬件数据',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/硬件数据'),
                path: "华美顾问/华美服务/五星酒店/硬件数据"
            },
            {
                name: '亮点分析',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/亮点分析'),
                path: "华美顾问/华美服务/五星酒店/亮点分析"
            },
            {
                name: '房价趋势及对比',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/房价趋势及对比'),
                path: "华美顾问/华美服务/五星酒店/房价趋势及对比"
            },
            {
                name: '到底是谁',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/五星酒店/到底是谁'),
                path: "华美顾问/华美服务/五星酒店/到底是谁"
            },
        ]
    }]
}